import { Component, OnInit } from '@angular/core';
import { UserProfile } from '../../models/user-profile.model';
import { UtilService } from '../../service/util.service';
import { ReportService } from '../report/report.service';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UserData } from '../../providers/user-data';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Storage } from '@ionic/storage';
import { ServiceLevelComponent } from '../../component/advanced-filter/service-level/service-level.component';

@Component({
  selector: 'app-report-service-level',
  templateUrl: './report-service-level.page.html',
  styleUrls: ['./report-service-level.page.scss'],
})
export class ReportServiceLevelPage implements OnInit {

  rows: any=[];
  tempRows : any=[];
  keywordSearch:any='';
  token: any;
  userProfile: UserProfile = new UserProfile();
  userAccess: any[] = [];
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };
  counterList: any[] = [];
  counterId:any='';
  groupedBranches: any[] = [];

  paramProductReceivingId: any = null;
  paramProductRequestId: any = null;
  paramBranchIdList: any[]=[];
  paramCounterIdList: any[]=[];
  paramWarehouseIdList: any[]=[];
  paramDocStartDate: any = null;
  paramDocEndDate: any = null;
  paramPoType:any='0';
  branchList:any[]=[];
  warehouseList:any[]=[];
  branchNameList:any='';
  warehouseNameList:any='';
  counterNameList:any='';

  reportData: any[] = [];
  reportDataDetail: any[] = [];
  
  avgSlStock =0;
  avgSlTime = 0;
  avgKeterangan = '';

  constructor(
    private utilService:UtilService,
    private reportService: ReportService,
    private toastCtrl:ToastController,
    private navCtrl:NavController,
    private userData: UserData,
    private modalController:ModalController,
    private storage: Storage,
  ) { }

  ngOnInit() {
    
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userAccess = access;
          this.userProfile = new UserProfile(profile);
          let counterId = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
          this.reloadTable();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

groupData() {
  const groups: any = {};

  this.rows.forEach(row => {
    if (!groups[row.branch_id]) {
      groups[row.branch_id] = {
        branch_name: row.branch_name,
        rows: []
      };
    }

    groups[row.branch_id].rows.push(row);
  });

  this.groupedBranches = Object.values(groups);
}
branches: any[] = [];

activeBranch: number = null;
setBranches2() {
  const map = new Map();
  this.rows.forEach(r => {
    if (!map.has(r.branch_id)) {
      map.set(r.branch_id, {
        branch_id: r.branch_id,
        branch_name: r.branch_name
      });
    }
  });

  this.branches = Array.from(map.values());

  if (this.branches.length > 0) {
    this.activeBranch = this.branches[0].branch_id;
  }
}
setBranches() {
  const map = new Map();

  this.rows.forEach(r => {
    if (!map.has(r.branch_id)) {
      map.set(r.branch_id, {
        branch_id: r.branch_id,
        branch_name: r.branch_name,
        totalSlStock: 0,
        totalSlTime:0,
        count: 0,
        keterangan:''
      });
    }

    const branch = map.get(r.branch_id);
    branch.totalSlStock += parseInt(r.sl_stock) || 0; // jumlahkan sl_stock
    branch.totalSlTime += parseInt(r.sl_time) || 0; // jumlahkan sl_time
    branch.count += 1;
  });

  // Buat array akhir dengan average
  this.branches = Array.from(map.values()).map(b => {
    const averageSlStock = b.count > 0 ? +(b.totalSlStock / b.count).toFixed(2) : 0;
    const averageSlTime  = b.count > 0 ? +(b.totalSlTime / b.count).toFixed(2) : 0;

    let avgKeterangan = '';

    if (averageSlStock > 85 && averageSlTime === 100) {
      avgKeterangan = 'GOOD SL';
    } else if (averageSlStock > 85 && averageSlTime === 0) {
      avgKeterangan = 'BAD OTD';
    } else if (averageSlStock <= 85 && averageSlTime === 100) {
      avgKeterangan = 'BAD OFR';
    } else {
      avgKeterangan = 'BAD SL';
    }

    return {
      branch_id: b.branch_id,
      branch_name: b.branch_name,
      averageSlStock: Math.round(averageSlStock),
      averageSlTime: Math.round(averageSlTime),
      averageKeterangan: avgKeterangan
    };
  });

  // Set default active branch
  if (this.branches.length > 0) {
    this.activeBranch = this.branches[0].branch_id;
  }
}
getRowsByBranch(branchId: number) {
  return this.rows.filter(r => r.branch_id === branchId);
}
getActiveBranch() {
  return this.branches.find(b => b.branch_id === this.activeBranch);
}
  reloadTable() {
    this.avgSlStock =0
    this.avgSlTime = 0;
    this.avgKeterangan ='';
    this.rows =[];
    this.tempRows = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      let branchIds: any[]=[];
      let counterIds: any;
      let warehouseIds: any;
      let userCounterIds =  counterIds = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
      if(this.paramBranchIdList.length>0) { 
        branchIds = this.paramBranchIdList; 
      }
      if(this.paramCounterIdList.length>0) { 
        counterIds = this.paramCounterIdList; 
      }
      else { counterIds = userCounterIds;
      }
      if(this.paramWarehouseIdList.length>0) { 
        warehouseIds = this.paramWarehouseIdList; 
      }
      let convertDate = this.utilService.convertDate(new Date());
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let options = {
        "token": this.token,
        "page": offset.toString(),
        "branch_id_list": branchIds,
        "counter_id_list": counterIds,
        "warehouse_id_list": warehouseIds,
        "user_counter_id_list":userCounterIds,
        "product_request_id":this.paramProductRequestId,
        "product_receiving_id":this.paramProductReceivingId,
        "doc_start_date": this.paramDocStartDate ? this.paramDocStartDate : todayDate,
        "doc_end_date": this.paramDocEndDate ? this.paramDocEndDate : '4712-12-31',
        "po_type":this.paramPoType
      };
      this.reportService.reportServiceLevel(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.rows = response.results.data;
        this.setBranches();
        
        this.tempRows = response.results.data;
        
        this.branchList = response.results.branch_list;
        this.counterList = response.results.counter_list;
        this.warehouseList = response.results.warehouse_list;

        // Hitung average
        let totalSlStock = 0;
        let totalSlTime = 0;
        const count = this.rows.length;

        this.rows.forEach(row => {
          totalSlStock += row.sl_stock ? parseInt(row.sl_stock) : 0; // pastikan null-safe
         
          // SL Time: pastikan angka, jika string/invalid => 0
          const slTimeNum = parseInt(row.sl_time, 10); // parseInt untuk konversi string ke number
          totalSlTime += !isNaN(slTimeNum) ? slTimeNum : 0;
        });
        this.avgSlStock = count > 0 ? Math.round((totalSlStock / count)) : 0;
        this.avgSlTime = count > 0 ? Math.round((totalSlTime / count)) : 0;
        if (this.avgSlStock > 85 && this.avgSlTime === 100) {
          this.avgKeterangan = 'GOOD SL';
        } else if (this.avgSlStock > 85 && this.avgSlTime === 0) {
          this.avgKeterangan = 'BAD OTD';
        } else if (this.avgSlStock <= 85 && this.avgSlTime === 100) {
          this.avgKeterangan = 'BAD OFR';
        } else {
          this.avgKeterangan = 'BAD SL';
        }
        }, (err) => {
          this.utilService.loadingDismiss();
          if(err.error.error === 'token_expired') {
            this.userData.logout().then(() => {
              this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
              this.navCtrl.navigateForward(['/login']);
            });
          } else {
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          }
        });
      });
    }
  
  
    exportToExcel() {
    const element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
    // === AUTO WIDTH ===
    const colWidths = [];
    const range = XLSX.utils.decode_range(ws['!ref']!);
  
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let maxWidth = 10;
  
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[cellAddress];
        if (!cell || !cell.v) continue;
  
        const cellLength = cell.v.toString().length;
        maxWidth = Math.max(maxWidth, cellLength);
      }
  
      colWidths.push({ wch: maxWidth + 2 }); // +2 biar lega
    }
  
    ws['!cols'] = colWidths;
    // === END AUTO WIDTH ===
  
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    XLSX.writeFile(wb, 'Report Service Level.xlsx');
  }
  async openAdvancedFilters() {
    const modal = await this.modalController.create({
      component: ServiceLevelComponent,
      componentProps: {
        branchList:this.branchList,
        counterList: this.counterList,
        warehouseList: this.warehouseList,
        paramProductReceivingId: this.paramProductReceivingId,
        paramProductRequestId: this.paramProductRequestId,
        paramBranchIdList: this.paramBranchIdList,
        paramCounterIdList: this.paramCounterIdList,
        paramWarehouseIdList: this.paramWarehouseIdList,
        paramDocStartDate: this.paramDocStartDate,
        paramDocEndDate: this.paramDocEndDate,
        paramPoType:this.paramPoType
      },
      backdropDismiss: false
    });
    console.log("BRANCH")
    console.log(this.branchList);

    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      console.log(data)
      if (data.length > 0) {
        let arrBranch = [];
        if(data[0].branchId.length>0){
          for(let i=0;i<data[0].branchId.length;i++){
            arrBranch.push(data[0].branchId[i].id);
          }
        }
        let arrCounter = [];
        if(data[0].counterId.length>0){
          for(let i=0;i<data[0].counterId.length;i++){
            arrCounter.push(data[0].counterId[i].id);
          }
        }
        let arrWarehouse = [];
        if(data[0].warehouseId.length>0){
          for(let i=0;i<data[0].warehouseId.length;i++){
            arrWarehouse.push(data[0].warehouseId[i].id);
          }
        }
        this.paramProductReceivingId = data[0].productReceivingId;
        this.paramProductRequestId = data[0].productRequestId;
        this.paramBranchIdList = arrBranch;
        this.paramCounterIdList = arrCounter;
        this.counterNameList = data[0].counterName;
        this.paramWarehouseIdList = arrWarehouse;
        this.warehouseNameList = data[0].warehouseName;
        this.paramDocStartDate = data[0].docStartDate;
        this.paramDocEndDate = data[0].docEndDate;
        this.paramPoType = data[0].poType

        this.reloadTable();
      }
    });

    return await modal.present();
  }


  exportExcelMultiSheet2() {
  const wb = XLSX.utils.book_new();

  this.branches.forEach(branch => {
    const data = this.getRowsByBranch(branch.branch_id);

    // Buat data baru tanpa properti branch_id
    const filteredData = data.map(({ branch_id, ...rest }) => rest);

    const ws = XLSX.utils.json_to_sheet(filteredData);

    XLSX.utils.book_append_sheet(wb, ws, branch.branch_name.substring(0, 31));
  });

  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], { type: 'application/octet-stream' });
  saveAs(blob, 'Service Level.xlsx');
}
exportExcelMultiSheet3() {
  const wb = XLSX.utils.book_new();

  this.branches.forEach(branch => {
    const data = this.getRowsByBranch(branch.branch_id);

    // Buat data tanpa branch_id
    const filteredData = data.map(({ branch_id, ...rest }) => rest);

    // Buat worksheet dari data
    const ws = XLSX.utils.json_to_sheet(filteredData);

    // Hitung summary, misal total qty_po dan qty_kirim
    const totalQtyPo = filteredData.reduce((acc, cur) => acc + (cur.qty_po || 0), 0);
    const totalQtyKirim = filteredData.reduce((acc, cur) => acc + (cur.qty_kirim || 0), 0);

    // Cari baris terakhir data (jumlah rows + 1 header)
    const lastRow = filteredData.length + 1;

    // Tambah summary di bawah data (misal di kolom D dan E)
    // XLSX cell address itu kolom huruf + nomor baris, dimulai dari 1
    ws[`H${lastRow + 2}`] = { t: 's', v: 'Average:' };
    ws[`I${lastRow + 2}`] = { t: 'n', v: this.avgSlStock };
    ws[`J${lastRow + 2}`] = { t: 'n', v: this.avgSlTime };
    ws[`K${lastRow + 2}`] = { t: 's', v: this.avgKeterangan };

    // Update range agar Excel baca sampai baris terakhir + summary
    const range = XLSX.utils.decode_range(ws['!ref']!);
    range.e.r = lastRow + 2; // tambah 2 baris untuk summary
    ws['!ref'] = XLSX.utils.encode_range(range);

    XLSX.utils.book_append_sheet(wb, ws, branch.branch_name.substring(0, 31));
  });

  // Export file
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], { type: 'application/octet-stream' });
  saveAs(blob, 'Service Level.xlsx');
}
exportExcelMultiSheet() {
  const wb = XLSX.utils.book_new();

  this.branches.forEach(branch => {
    // Ambil rows branch
    const data = this.getRowsByBranch(branch.branch_id);
    const filteredData = data.map(({ branch_id,branch_name, ...rest }) => ({
      ...rest,
      sl_stock: rest.sl_stock ? `${rest.sl_stock}%` : null,
      sl_time: rest.sl_time ? `${rest.sl_time}%` : null
    }));

    // Worksheet dari data
    const ws = XLSX.utils.json_to_sheet(filteredData);

    // Baris terakhir data
    const lastRow = filteredData.length + 1;

    // Tambahkan summary otomatis dari branch.averageSlStock & averageKeterangan
    ws[`G${lastRow + 2}`] = { t: 's', v: 'Average:' };
    ws[`H${lastRow + 2}`] = { t: 's', v: branch.averageSlStock + '%'};
    ws[`I${lastRow + 2}`] = { t: 's', v: branch.averageSlTime + '%'};
    ws[`J${lastRow + 2}`] = { t: 's', v: branch.averageKeterangan };

    // Update worksheet range
    const range = XLSX.utils.decode_range(ws['!ref']!);
    range.e.r = lastRow + 2; // termasuk 2 baris summary
    ws['!ref'] = XLSX.utils.encode_range(range);

    // Tambahkan sheet ke workbook
    XLSX.utils.book_append_sheet(wb, ws, branch.branch_name.substring(0, 31));
  });

  // Export file
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], { type: 'application/octet-stream' });
  saveAs(blob, 'Service Level.xlsx');
}
}
